import { useCallback, useState } from 'react';
import { getReferenceScrollTarget } from './viewerState';
import type { AnchorScrollTarget, ReferenceContentState } from './types';

export const useFacesheetReferenceScroll = () => {
  const [targetPage, setTargetPageState] = useState<number | undefined>();
  const [anchorScrollTarget, setAnchorScrollTarget] = useState<
    AnchorScrollTarget | undefined
  >();
  const [anchorScrollKey, setAnchorScrollKey] = useState(0);

  const clearScroll = useCallback(() => {
    setTargetPageState(undefined);
    setAnchorScrollTarget(undefined);
  }, []);

  const handlePageChange = useCallback(() => {
    clearScroll();
  }, [clearScroll]);

  const setTargetPage = useCallback((page: number | undefined) => {
    setTargetPageState(page);
    setAnchorScrollTarget(undefined);
  }, []);

  const syncToReference = useCallback(
    (referenceId: string, reference: ReferenceContentState) => {
      const scrollTarget = getReferenceScrollTarget(reference, referenceId);

      if (scrollTarget.targetPage !== undefined) {
        setTargetPageState(scrollTarget.targetPage);
        setAnchorScrollTarget(undefined);
        return;
      }

      if (scrollTarget.anchorScrollTarget) {
        setTargetPageState(undefined);
        setAnchorScrollTarget(scrollTarget.anchorScrollTarget);
        setAnchorScrollKey((key) => key + 1);
      }
    },
    [],
  );

  return {
    targetPage,
    anchorScrollTarget,
    anchorScrollKey,
    clearScroll,
    handlePageChange,
    syncToReference,
    setTargetPage,
  };
};
